<template>
<!-- eslint-disable max-len -->
<div class="budgets-bar btn-white">
  <h3 ref="budgetTextContainer" class="budgeted-text-container" v-if="overrideBudgetTitle">{{overrideBudgetTitle}}</h3>
  <h3 ref="budgetTextContainer" class="budgeted-text-container" v-else-if="showBudgetUsed">Budgeted <span class="currency">{{ budgetUsed | currency }}</span> of <span class="currency">{{ totalBudget | currency }}</span></h3>
  <h3 ref="budgetTextContainer" class="budgeted-text-container" v-else>Total Available Budget: <span class="currency">{{ totalBudget | currency }}</span></h3>

  <div ref="barBack" class="bar-back">
    <div v-for="(choice, i) in choices" :key="i" class="bar-part" :style="{ 'background-color': colors[i], width: `${choice.allocation / totalBudget * 100}%`, 'border-right-width': `${choice.allocation > 0 ? 3 : 0}px` }"></div>
  </div>
</div>
</template>

<script>
import fitty from 'fitty';

export default {
  props: {
    totalBudget: { type: Number },
    choices: { type: Array },
    colors: { type: Array },
    showBudgetUsed: { type: Boolean },
    overrideBudgetTitle: { type: String }
  },
  computed: {
    budgetUsed() {
      return this.choices.reduce((acc, choice) => acc + choice.allocation, 0);
    }
  },
  watch: {
    budgetUsed() {
      if (this.fit) {
        this.fit.fit();
      }
    }
  },
  data() {
    return {
      fit: undefined
    };
  },
  mounted() {
    // eslint-disable-next-line new-cap
    this.fit = fitty(this.$refs.budgetTextContainer, {
      minSize: 20, maxSize: 35, multiLine: false
    });
  },
  beforeDestroy() {
    if (this.fit) {
      this.fit.unsubscribe();
      this.fit = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.budgets-bar {
  height: 110px;
  padding: 10px 15px 15px 15px;
  margin-bottom: 10px;
  color: black;
}
.budgets-bar h3 {
  float: left;
  font-size: 45px;
  font-weight: bold;
  display: inline-block;
  margin: 0;
}
.budgets-bar p {
  float: right;
  font-size: 45px;
  line-height: 55px;
  font-weight: bold;
  display: inline-block;
  margin: 0;
}
.bar-back {
  width: 100%;
  height: 28px;
  background-color: #E7E7E7;
  //border: 3px solid var(--primaryColor);
  box-shadow: 0px 2px 5px rgba(0,0,0,0.5);
  clear: both;
  display: inline-block;
}
.bar-part {
  float: left;
  height: 28px;
  //margin-top: -1px;
  border-right-color: #F1F3F2;
  border-right-style: solid;
  display: inline-block;
}
.currency::before {
  font-size: 32px;
}

.budgeted-text-container
{
  width: 550px;
  height: 50px;
  font-size: 28px;
  //background-color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/BudgetsBar.vue